var IMG_BASE = (window.BC_IMG_BASE || '');

(function() {

  /* ═══════════════════════════════════════════════════════
     QUIZ DATA
  ═══════════════════════════════════════════════════════ */
  var QUESTIONS = [
    {
      eyebrow: 'VOS CAPSULES',
      hook: 'Quelle capsule utilisez-vous aujourd\'hui ?',
      type: 'grid',
      options: [
        { label: 'Capsules Nespresso® Original ou compatible',  img: 'capsule-nes.png' },
        { label: 'Nespresso® Vertuo',    img: 'capsules-nespresso-vertuo.png' },
        { label: 'Nescafé® Dolce Gusto®',         img: 'capsule-ndg.png' },
        { label: 'Senseo®',              img: 'capsule-sen.png' },
        { label: 'Tassimo®',             img: 'capsule-tassimo.webp' },
        { label: 'Autre',        img: 'capsule-autres.png' }
      ]
    },
    {
      eyebrow: 'VOTRE FOYER',
      hook: 'Dans votre foyer, qui consomme du café tous les jours ?',
      type: 'list',
      hasFamily: true,
      options: [
        { label: 'Moi uniquement' },
        { label: 'Moi et mon conjoint(e)' },
        { label: 'Toute la famille (3 personnes ou plus)' }
      ]
    },
    {
      eyebrow: 'VOS HABITUDES',
      hook: 'Combien de cafés consommez-vous en moyenne par jour par personne ?',
      type: 'list',
      options: [
        { label: '1 ou moins' },
        { label: '1 à 2' },
        { label: '3 à 4' },
        { label: '5 ou plus' }
      ]
    },
    {
      eyebrow: 'VOS ACHATS',
      hook: 'Où achetez-vous votre café ?',
      type: 'list',
      options: [
        { label: 'En supermarché' },
        { label: 'Sur Internet (Amazon ou autre)' },
        { label: 'Directement chez la marque' },
        { label: 'En boutique spécialisée' },
        { label: 'Un mélange de plusieurs canaux' }
      ]
    },
    {
      eyebrow: 'VOS ENVIES',
      hook: 'Qu\'aimeriez-vous améliorer dans votre routine café ?',
      type: 'list',
      options: [
        { label: 'Payer moins cher' },
        { label: 'Tester des cafés différents' },
        { label: 'Arrêter de jeter des capsules' },
        { label: 'Améliorer la qualité de mon café' },
        { label: 'Je suis satisfait(e) mais curieux(se)' }
      ]
    }
  ];

  var CDN = 'https://cdn.shopify.com/s/files/1/0564/1768/1578/files';
  var MACHINE_PRICES = {
    nes:    { prixActuel: 0.32,  benchmark: 0.165, economie: 0.155, label: 'Nespresso Original®' },
    ndg:    { prixActuel: 0.30,  benchmark: 0.09,  economie: 0.21,  label: 'Dolce Gusto®' },
    sen:    { prixActuel: 0.18,  benchmark: 0.09,  economie: 0.09,  label: 'Senseo®' },
    vertuo: { prixActuel: 0.29,  benchmark: 0.09,  economie: 0.20,  label: 'Nespresso Vertuo®' },
    autre:  { prixActuel: 0.49,  benchmark: 0.09,  economie: 0.40,  label: 'Autre machine' }
  };
  var MACHINE_DATA = {
    nes: { color: '#193254', packshot: CDN + '/PackShot_BoiteCoffret_NES_Shaker_Black_Contenu.png?v=1775486147',  productUrl: 'https://www.capsme.fr/products/coffret-capsules-reutilisables-capsme-compatible-avec-les-machines-nespresso-et-lor-barista' },
    ndg: { color: '#cd5451', packshot: CDN + '/PackShot_BoiteCoffret_NDG_Shaker_Black_Contenu.webp?v=1775487570', productUrl: 'https://www.capsme.fr/products/coffret-capsules-reutilisables-capsme-compatible-avec-les-machines-nescafe-dolce-gusto' },
    sen: { color: '#4c6b45', packshot: CDN + '/PackShot_BoiteCoffret_SEN_Shaker_Black_Contenu.webp?v=1775487640', productUrl: 'https://www.capsme.fr/products/coffret-capsules-reutilisables-capsme-compatible-avec-les-machines-senseo' }
  };
  var PHOTOS = {
    intro: { src: IMG_BASE + 'intro.jpg',  label: 'Calculateur gratuit', sub: 'Vos économies café en 2 min' },
    q0:    { src: IMG_BASE + 'q1.webp',     label: 'Votre machine',       sub: 'NES · Vertuo · DG · Senseo · Tassimo' },
    q1:    { src: IMG_BASE + 'q2.webp',     label: 'Votre foyer',         sub: 'Qui boit du café au quotidien ?' },
    q2:    { src: IMG_BASE + 'q3.jpg',     label: 'Vos habitudes',       sub: 'Cafés bus par jour' },
    q3:    { src: IMG_BASE + 'q5.webp',     label: 'Vos achats',          sub: 'Où achetez-vous votre café ?' },
    q4:    { src: IMG_BASE + 'q6.webp',     label: 'Vos envies',          sub: 'Ce que vous voulez améliorer' },
    email: { src: IMG_BASE + 'email2.webp', label: 'Dernière étape',      sub: 'Votre simulation personnalisée' }
  };
  var TRANSITION_STEPS = [
    { text: 'Analyse de votre consommation…',      icon: '☕' },
    { text: 'Calcul des économies potentielles…',  icon: '☕' },
    { text: 'Génération de votre rapport…',        icon: '💰' }
  ];

  /* Quiz state */
  var QZ = { step: 'intro', qIdx: 0, answers: {}, familyCount: 3, savings: 0, prenom: '' };

  /* ── BC Tracker — funnel quiz (view → start → answer → email → complete) ──
     Le quiz est une SPA à état interne : ses étapes ne sont pas des sections DOM,
     donc bc-tracker.js (IntersectionObserver au scroll) ne peut pas les voir. On
     émet donc nous-mêmes un event par transition, directement vers l'OS (même
     pattern cross-domain que l'appel Klaviyo). On réutilise le sid/vid posés par
     bc-tracker sur capsme.fr (cookie bc_sid + localStorage _bc_vid) pour que les
     achats se rattachent à la session (jointure quiz_sessions ↔ shopify_events). */
  var BCQ_URL = 'https://os-cro.vercel.app/api/bc/quiz';
  var BCQ_SITE = 'capsme';
  var BCQ_SLUG = 'capsme-quiz';
  var bcqViewSent = false;
  function bcqSid() {
    try {
      var m = document.cookie.match(/(?:^|;\s*)bc_sid=([^;]+)/);
      if (m) { var s = JSON.parse(decodeURIComponent(m[1])); if (s && s.sid) return s.sid; }
    } catch (e) {}
    /* Fallback : sid local propre au quiz — funnel OK, attribution achat en moins. */
    try {
      var l = localStorage.getItem('_bc_quiz_sid');
      if (!l) { l = 'q_' + Math.random().toString(36).slice(2) + Date.now().toString(36); localStorage.setItem('_bc_quiz_sid', l); }
      return l;
    } catch (e) { return 'q_anon'; }
  }
  function bcqUtms() {
    try { var r = localStorage.getItem('_bc_utms'); if (r) { var p = JSON.parse(r); return (p && p.utms) || {}; } } catch (e) {}
    return {};
  }
  function bcq(type, data) {
    var vid = '';
    try { vid = localStorage.getItem('_bc_vid') || ''; } catch (e) {}
    var p = { sid: bcqSid(), vid: vid, site: BCQ_SITE, quiz_slug: BCQ_SLUG, event_type: type, data: data || {}, url: location.href };
    if (type === 'view') {
      var u = bcqUtms(), w = window.innerWidth || 0;
      p.session = {
        referrer: document.referrer || '',
        viewport: w + 'x' + (window.innerHeight || 0),
        device: (w && w < 768) ? 'mobile' : 'desktop',
        utm_source: u.utm_source || '', utm_medium: u.utm_medium || '',
        utm_campaign: u.utm_campaign || '', utm_content: u.utm_content || ''
      };
    }
    /* keepalive : garantit l'envoi de « complete » malgré la transition d'écran. */
    try {
      fetch(BCQ_URL, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(p), keepalive: true, mode: 'cors' }).catch(function () {});
    } catch (e) { /* le tracking ne doit jamais casser le quiz */ }
  }
  function bcqView() { if (bcqViewSent) return; bcqViewSent = true; bcq('view'); }

  /* ── Helpers ── */
  function getMachineKey() {
    var a = QZ.answers[0] || '';
    if (a.indexOf('Original') !== -1) return 'nes';
    if (a.indexOf('Dolce Gusto') !== -1) return 'ndg';
    if (a.indexOf('Senseo') !== -1) return 'sen';
    if (a.indexOf('Vertuo') !== -1) return 'vertuo';
    return 'autre';
  }
  function getCafesJour() {
    var a = QZ.answers[2] || '';
    if (a.indexOf('1 ou') !== -1) return 1;
    if (a.indexOf('1 à 2') !== -1) return 2;
    if (a.indexOf('3 à 4') !== -1) return 3;
    if (a.indexOf('5') !== -1) return 5;
    return 1;
  }
  function getPersonnes() {
    var a = QZ.answers[1] || '';
    if (a.indexOf('Moi uniquement') !== -1) return 1;
    if (a.indexOf('conjoint') !== -1) return 2;
    var m = a.match(/(\d+)\s*pers/);
    if (m) return parseInt(m[1]);
    if (a.indexOf('famille') !== -1) return 3;
    return 1;
  }
  function calcSavings() {
    var key = getMachineKey();
    var p = MACHINE_PRICES[key];
    var cafes = getCafesJour();
    var pers  = getPersonnes();
    return Math.round(p.economie * cafes * pers * 365);
  }

  /* ── Shell class helper ── */
  function setShellClass(cls) {
    var shell = document.getElementById('quiz-shell');
    shell.className = 'quiz-shell quiz-shell--' + cls;
  }

  /* ── Photo panel update ── */
  function updatePhoto(key) {
    var ph = PHOTOS[key];
    if (!ph) return;
    var img = document.getElementById('right-photo-img');
    var lbl = document.getElementById('right-caption-label');
    var sub = document.getElementById('right-caption-sub');
    var mImg = document.getElementById('mob-photo-img');
    var mLbl = document.getElementById('mob-photo-label');
    var mSub = document.getElementById('mob-photo-sub');
    if (img) {
      img.style.opacity = '0';
      (function(el, src) {
        setTimeout(function() { el.src = src; el.style.opacity = '1'; }, 180);
      })(img, ph.src);
    }
    if (lbl) lbl.textContent = ph.label;
    if (sub) sub.textContent = ph.sub;
    if (mImg) {
      mImg.style.opacity = '0';
      (function(el, src) {
        setTimeout(function() { el.src = src; el.style.opacity = '1'; }, 220);
      })(mImg, ph.src);
    }
    if (mLbl) mLbl.textContent = ph.label;
    if (mSub) mSub.textContent = ph.sub;
  }

  /* ── Show/hide screens ── */
  function showScreen(id) {
    document.querySelectorAll('.qz-screen').forEach(function(s) { s.classList.remove('is-active'); });
    var el = document.getElementById(id);
    if (el) el.classList.add('is-active');
    var footer = document.getElementById('quiz-footer');
    var reass  = document.getElementById('intro-reassurance');
    if (footer) {
      footer.style.display = (id === 'scr-quiz') ? 'flex' : 'none';
    }
    if (reass)  reass.style.display  = (id === 'scr-intro') ? 'flex' : 'none';
  }

  /* ── Back btn ── */
  function updateBackBtn() {
    var btn = document.getElementById('qz-back-btn');
    var mobBtn = document.getElementById('qz-mob-back-btn');
    if (!btn) return;
    var visible = (QZ.step === 'quiz' && QZ.qIdx > 0) || QZ.step === 'email';
    btn.style.display = visible ? 'flex' : 'none';
    if (mobBtn) mobBtn.style.display = visible ? 'flex' : 'none';
  }

  /* ── Info popup — Q1 machine image ── */
  function openInfoPopup(imgSrc, label) {
    document.getElementById('q1-info-img').src = imgSrc;
    document.getElementById('q1-info-label').textContent = label;
    document.getElementById('q1-info-overlay').classList.add('is-open');
  }
  function closeInfoPopup() {
    document.getElementById('q1-info-overlay').classList.remove('is-open');
  }
  window.openInfoPopup = openInfoPopup;
  window.closeInfoPopup = closeInfoPopup;

  /* ── Progress bar — segmented ── */
  var SEG_LABELS = ['Machine', 'Habitudes', 'Foyer', 'Budget', 'Achats'];

  function updateProgress() {
    for (var i = 0; i < QUESTIONS.length; i++) {
      var fill = document.getElementById('qz-seg-' + i);
      var btn  = document.getElementById('qz-seg-btn-' + i);
      if (!fill) continue;
      var isPast = (QZ.step === 'email') ? true : (i < QZ.qIdx);
      var isCurrent = (QZ.step === 'quiz') && (i === QZ.qIdx);
      var isClickable = (QZ.step === 'quiz') && (i < QZ.qIdx);
      if (isPast || isCurrent) {
        fill.style.width = '100%';
        fill.style.backgroundColor = isPast ? '#FFC823' : '#11312b';
      } else {
        fill.style.width = '0%';
        fill.style.backgroundColor = '';
      }
      if (btn) {
        if (isClickable) {
          btn.classList.add('seg-clickable');
          btn.setAttribute('data-label', SEG_LABELS[i] + ' ✓');
          btn.setAttribute('aria-label', 'Revenir à ' + SEG_LABELS[i]);
        } else {
          btn.classList.remove('seg-clickable');
          btn.removeAttribute('data-label');
          btn.removeAttribute('aria-label');
        }
      }
    }
    var counter = document.getElementById('qz-counter');
    if (counter) {
      if (QZ.step === 'quiz') counter.textContent = 'QUESTION ' + (QZ.qIdx + 1) + ' / ' + QUESTIONS.length;
      else if (QZ.step === 'email') counter.textContent = 'Votre résultat vous attend';
      else counter.textContent = '';
    }
  }

  /* ── Jump to past step ── */
  window.qzJumpToStep = function(i) {
    if (QZ.step !== 'quiz' || i >= QZ.qIdx) return;
    QZ.qIdx = i;
    renderQuestion(i);
    updateProgress();
    updateBackBtn();
    var col = document.getElementById('quiz-col-left');
    if (col) col.scrollTop = 0;
  };

  /* ── Mob photo wrap ── */
  function updateMobPhoto() {
    var wrap = document.getElementById('mob-photo-wrap');
    if (!wrap) return;
    if (QZ.step === 'quiz' || QZ.step === 'email') {
      wrap.style.display = ''; /* retire l'inline style → CSS media query contrôle */
    } else {
      wrap.style.display = 'none';
    }
  }

  /* ── Start quiz ── */
  window.qzStart = function() {
    bcq('start');
    QZ.step = 'quiz'; QZ.qIdx = 0;
    setShellClass('quiz');
    renderQuestion(0);
    updateBackBtn();
    updateProgress();
    updateMobPhoto();
  };

  /* ── Back ── */
  window.qzBack = function() {
    if (QZ.step === 'email') {
      QZ.step = 'quiz'; QZ.qIdx = QUESTIONS.length - 1;
      renderQuestion(QZ.qIdx);
    } else if (QZ.step === 'quiz' && QZ.qIdx > 0) {
      QZ.qIdx--;
      renderQuestion(QZ.qIdx);
    }
    updateBackBtn();
    updateProgress();
    updateMobPhoto();
  };

  /* ── Eyebrow icons (one per question) ── */
  var EYEBROW_ICONS_SVG = [
    '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 8h1a4 4 0 1 1 0 8h-1"/><path d="M3 8h14v9a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4z"/><line x1="6" y1="2" x2="6" y2="4"/><line x1="10" y1="2" x2="10" y2="4"/><line x1="14" y1="2" x2="14" y2="4"/></svg>',
    '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>',
    '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/><polyline points="17 6 23 6 23 12"/></svg>',
    '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>',
    '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2l2.4 7.4H22l-6.2 4.5 2.4 7.4L12 17l-6.2 4.3 2.4-7.4L2 9.4h7.6z"/></svg>'
  ];

  /* ── Per-question icons for answer badges (Q1–Q4) ── */
  var Q_ICONS_SVG = {
    1: [
      '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="8" r="4"/><path d="M5 20c0-3.9 3.1-7 7-7s7 3.1 7 7"/></svg>',
      '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>',
      '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/><circle cx="20" cy="5" r="2"/></svg>'
    ],
    2: [
      '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 8h1a4 4 0 1 1 0 8h-1"/><path d="M3 8h14v9a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4z"/><line x1="6" y1="2" x2="6" y2="4"/><line x1="10" y1="2" x2="10" y2="4"/><line x1="14" y1="2" x2="14" y2="4"/></svg>',
      '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 8h1a4 4 0 1 1 0 8h-1"/><path d="M3 8h14v9a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4z"/><line x1="6" y1="2" x2="6" y2="4"/><line x1="10" y1="2" x2="10" y2="4"/></svg>',
      '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 8h1a4 4 0 1 1 0 8h-1"/><path d="M3 8h14v9a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4z"/><line x1="6" y1="2" x2="6" y2="4"/><line x1="14" y1="2" x2="14" y2="4"/></svg>',
      '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 8h1a4 4 0 1 1 0 8h-1"/><path d="M3 8h14v9a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4z"/><line x1="10" y1="2" x2="10" y2="5"/></svg>'
    ],
    3: [
      '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>',
      '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="3" width="20" height="14" rx="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/></svg>',
      '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg>',
      '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>'
    ],
    4: [
      '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 12c0-3.87-3.13-7-7-7s-7 3.13-7 7c0 2.02.86 3.84 2.24 5.12L7 19h10l-.24-1.88A6.97 6.97 0 0 0 19 12z"/><line x1="12" y1="17" x2="12" y2="22"/><line x1="9" y1="21" x2="15" y2="21"/><circle cx="15" cy="10" r="1" fill="currentColor"/></svg>',
      '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.5 19 4c0 4-2 7-6 8.5a6 6 0 0 1-2 7.5z"/><path d="M5 21c0-3 3-6 6-8"/></svg>',
      '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 3h6M9 3v8l-4 9h14l-4-9V3"/><line x1="9" y1="11" x2="15" y2="11"/></svg>',
      '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>'
    ]
  };

  /* ── Q0 hover images (right-col swap) — React v2 Q1_META ── */
  var Q1_HOVER = [
    'q4-hover-nes.webp',
    'q4-hover-vertuo.webp',
    'q4-hover-ndg.webp',
    'q4-hover-sen.webp',
    'q4-hover-tassimo.webp',
    'q4-hover-autre.webp'
  ];

  /* ── Render question — React v2 exact ── */
  /* Builds question DOM (eyebrow, hook, answers) without triggering screen/animations */
  function _buildQuestion(idx) {
    var q = QUESTIONS[idx];
    var LETTERS = ['A','B','C','D','E','F','G'];
    var eyebrowIcon = document.getElementById('qz-q-eyebrow-icon');
    if (eyebrowIcon) eyebrowIcon.innerHTML = EYEBROW_ICONS_SVG[idx] || EYEBROW_ICONS_SVG[0];
    document.getElementById('qz-q-eyebrow').textContent = q.eyebrow;
    document.getElementById('qz-q-hook').textContent    = q.hook;

    /* Per-question stat hook */
    var statHookEl = document.getElementById('qz-q-stat-hook');
    if (statHookEl) {
      if (idx === 0) {
        statHookEl.innerHTML = '<div class="q1-hero-stat"><span class="q1-hero-stat-pct">50 %</span><span class="q1-hero-stat-text">du co\xFBt d’une capsule jetable vient de l’emballage \xE0 usage unique.</span></div>';
      } else if (idx === 1) {
        statHookEl.innerHTML = '<div class="q1-hero-stat"><span class="q1-hero-stat-text">Plus il y a de buveurs, plus l’\xE9conomie potentielle augmente.</span></div>';
      } else if (idx === 2) {
        statHookEl.innerHTML = '<div class="q1-hero-stat"><span class="q1-hero-stat-text"><span style="color:#FFC823;font-weight:700">Avec Caps’me</span>, vous pouvez pr\xE9parer <span style="color:#FFC823;font-weight:700">plus de 1 000 caf\xE9s</span> en rechargeant une seule capsule.</span></div>';
      } else if (idx === 3) {
        statHookEl.innerHTML = '<div class="q7-hook"><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/><polyline points="17 6 23 6 23 12"/></svg><span>Vos r\xE9ponses r\xE9v\xE8lent d\xE9j\xE0 <strong>plus de 100€ d’\xE9conomies</strong>.</span></div>';
      } else {
        statHookEl.innerHTML = '';
      }
    }

    var answersEl = document.getElementById('qz-q-answers');
    answersEl.innerHTML = '';
    answersEl.className = 'answers' + (idx === 0 ? ' q1-answers' : '');

    q.options.forEach(function(opt, i) {
      var letter = LETTERS[i] || String(i + 1);
      var badge;
      if (idx === 0 && opt.img) {
        badge = '<div class="answer-badge answer-badge--img"><img src="' + IMG_BASE + opt.img + '" alt="" class="answer-badge-img"></div>';
      } else if (Q_ICONS_SVG[idx] && Q_ICONS_SVG[idx][i]) {
        badge = '<div class="answer-badge">' + Q_ICONS_SVG[idx][i] + '</div>';
      } else {
        badge = '<div class="answer-badge"><span style="font-size:11px;font-weight:700;letter-spacing:.02em">' + letter + '</span></div>';
      }
      var arrow = '<div class="answer-arrow"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><polyline points="9 18 15 12 9 6"/></svg></div>';
      var check = '<div class="answer-check"><svg width="11" height="11" viewBox="0 0 13 13" fill="none"><path d="M2.5 6.5L5 9L10.5 3.5" stroke="#11312b" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg></div>';
      var infoBtn = '';
      if (idx === 0 && Q1_HOVER[i]) {
        var hoverSrc = IMG_BASE + '' + Q1_HOVER[i];
        var infoLabel = opt.label.replace(/'/g, "\\'");
        infoBtn = '<div role="button" tabindex="0" class="answer-info-btn" onclick="event.stopPropagation();openInfoPopup(\'' + hoverSrc + '\',\'' + infoLabel + '\')" aria-label="Voir la machine"><em>i</em></div>';
      }
      var stepperHtml = '';
      if (q.hasFamily && opt.label.indexOf('famille') !== -1) {
        stepperHtml = '<div class="answer-family-stepper" id="qz-family-stepper" style="display:none">'
          + '<div class="answer-family-label">Combien de personnes exactement ?</div>'
          + '<div class="answer-family-count-row">'
          + '<button type="button" class="answer-family-step-btn" onclick="qzFamilyStep(-1)">−</button>'
          + '<span class="answer-family-count" id="qz-family-count">3</span>'
          + '<button type="button" class="answer-family-step-btn" onclick="qzFamilyStep(1)">+</button>'
          + '<span style="font-size:.78rem;color:rgba(17,49,43,.5)">pers.</span>'
          + '</div>'
          + '<button type="button" class="answer-family-confirm" onclick="qzFamilyConfirm()">Confirmer</button>'
          + '</div>';
      }
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'answer-btn';
      btn.innerHTML = '<div class="answer-inner">'
        + '<div class="answer-left-accent"></div>'
        + badge
        + '<span class="answer-text">' + opt.label + '</span>'
        + infoBtn + arrow + check + stepperHtml
        + '</div>';
      btn.addEventListener('click', (function(thisBtnRef, optLabel) {
        return function() {
          /* Family option — expand stepper, no advance */
          if (q.hasFamily && optLabel.indexOf('famille') !== -1) {
            qzAnswer(idx, optLabel, q);
            return;
          }
          /* Prevent double-click */
          var allBtns = answersEl.querySelectorAll('.answer-btn');
          allBtns.forEach(function(b) { b.style.pointerEvents = 'none'; });
          /* Visual feedback — selected + dim others */
          allBtns.forEach(function(b) {
            b.classList.remove('is-dimmed');
            if (b !== thisBtnRef) b.classList.add('is-dimmed');
          });
          thisBtnRef.querySelector('.answer-inner').classList.add('selected');
          /* Navigate after delay */
          setTimeout(function() { qzAnswer(idx, optLabel, q); }, 450);
        };
      })(btn, opt.label));
      /* Q0: hover swaps right-column photo with opacity crossfade */
      if (idx === 0 && Q1_HOVER[i]) {
        (function(hoverFile) {
          btn.addEventListener('mouseenter', function() {
            var img = document.getElementById('right-photo-img');
            if (!img) return;
            img.style.opacity = '0';
            setTimeout(function() {
              img.src = IMG_BASE + '' + hoverFile;
              img.style.opacity = '1';
            }, 180);
          });
          btn.addEventListener('mouseleave', function() {
            var img = document.getElementById('right-photo-img');
            var p = PHOTOS['q0'];
            if (!img || !p) return;
            img.style.opacity = '0';
            setTimeout(function() {
              img.src = p.src;
              img.style.opacity = '1';
            }, 180);
          });
        })(Q1_HOVER[i]);
      }
      answersEl.appendChild(btn);
    });

  }

  function renderQuestion(idx) {
    var isFirstShow = !document.getElementById('scr-quiz').classList.contains('is-active');
    var qzInner = document.querySelector('#scr-quiz .qz-quiz-inner');

    if (!isFirstShow && qzInner) {
      /* Question→question : exit OLD content first, then rebuild + enter */
      qzInner.classList.remove('entering','entering-q0');
      qzInner.classList.add('exiting');
      setTimeout(function() {
        _buildQuestion(idx);
        updatePhoto('q' + idx);
        qzInner.classList.remove('exiting');
        void qzInner.offsetWidth;
        qzInner.classList.add('entering');
        triggerQzStagger(idx);
      }, 180);
    } else {
      /* First show (intro → quiz) */
      _buildQuestion(idx);
      updatePhoto('q' + idx);
      showScreen('scr-quiz');
      requestAnimationFrame(function() {
        if (qzInner) {
          qzInner.classList.remove('entering','entering-q0','exiting');
          void qzInner.offsetWidth;
          qzInner.classList.add('entering-q0');
        }
        triggerQzStagger(idx);
      });
    }
  }

  /* Stagger anim helper */
  function triggerQzStagger(idx) {
    function reAnim(el, cls) {
      if (!el) return;
      el.classList.remove(cls);
      void el.offsetWidth;
      el.classList.add(cls);
    }
    reAnim(document.querySelector('#scr-quiz .q-eyebrow'), 'qz-anim-eyebrow');
    reAnim(document.getElementById('qz-q-hook'), 'qz-anim-title');
    var hook = document.getElementById('qz-q-stat-hook');
    if (hook && hook.children.length > 0) reAnim(hook, 'qz-anim-hook');
    document.querySelectorAll('#qz-q-answers .answer-btn').forEach(function(btn, i) {
      btn.classList.remove('qz-anim-ans-0','qz-anim-ans-1','qz-anim-ans-2','qz-anim-ans-3','qz-anim-ans-4','qz-anim-ans-5');
      void btn.offsetWidth;
      btn.classList.add('qz-anim-ans-' + Math.min(i, 5));
    });
  }

  /* ── Answer ── */
  window.qzAnswer = function(qIdx, label, q) {
    /* Family stepper */
    if (q && q.hasFamily && label.indexOf('famille') !== -1) {
      QZ.familyCount = 3;
      var countEl = document.getElementById('qz-family-count');
      if (countEl) countEl.textContent = 3;
      var stepper = document.getElementById('qz-family-stepper');
      if (stepper) {
        stepper.style.display = 'flex';
        var inner = stepper.parentElement;
        if (inner) inner.classList.add('answer-inner--expanded', 'selected');
        var acc = inner ? inner.querySelector('.answer-left-accent') : null;
        if (acc) acc.style.transform = 'scaleX(0)';
      }
      return;
    }
    /* Collapse any open family stepper */
    var stepper = document.getElementById('qz-family-stepper');
    if (stepper) {
      stepper.style.display = 'none';
      var inner = stepper.parentElement;
      if (inner) { inner.classList.remove('answer-inner--expanded'); inner.classList.remove('selected'); }
    }
    /* Save answer + navigate */
    QZ.answers[qIdx] = label;
    bcq('answer', { step: qIdx });
    if (qIdx < QUESTIONS.length - 1) {
      QZ.qIdx = qIdx + 1;
      renderQuestion(QZ.qIdx);
      updateProgress();
      updateBackBtn();
      var col = document.getElementById('quiz-col-left');
      if (col) col.scrollTop = 0;
    } else {
      qzShowEmail();
    }
  };

  /* ── Family stepper ── */
  window.qzFamilyStep = function(delta) {
    QZ.familyCount = Math.max(3, Math.min(10, QZ.familyCount + delta));
    document.getElementById('qz-family-count').textContent = QZ.familyCount;
  };
  window.qzFamilyConfirm = function() {
    QZ.answers[1] = 'Toute la famille (' + QZ.familyCount + ' pers.)';
    bcq('answer', { step: 1 });
    var stepper = document.getElementById('qz-family-stepper');
    if (stepper) {
      stepper.style.display = 'none';
      var inner = stepper.parentElement;
      if (inner) inner.classList.remove('answer-inner--expanded', 'selected');
    }
    QZ.qIdx = 2;
    renderQuestion(2);
    updateProgress();
    updateBackBtn();
    var col = document.getElementById('quiz-col-left');
    if (col) col.scrollTop = 0;
  };

  /* ── Email screen ── */
  function qzShowEmail() {
    QZ.step = 'email';
    bcq('email_view');
    var savings = calcSavings();
    QZ.savings = savings;
    var teaser = document.getElementById('qz-teaser-amount');
    if (teaser) teaser.textContent = 'Des économies potentielles ont été détectées sur votre consommation de café.';
    /* Restore prenom from localStorage */
    var prenomEl = document.getElementById('qz-prenom');
    if (prenomEl) prenomEl.value = localStorage.getItem('qz-prenom') || '';
    updatePhoto('email');
    setShellClass('quiz');
    showScreen('scr-email');
    updateBackBtn();
    updateProgress();
    updateMobPhoto();
    var col = document.getElementById('quiz-col-left');
    if (col) col.scrollTop = 0;
  }

  /* ── Email submit ── */
  window.qzEmailSubmit = function(e) {
    e.preventDefault();
    var emailEl  = document.getElementById('qz-email');
    var prenomEl = document.getElementById('qz-prenom');
    var errEl    = document.getElementById('qz-email-error');
    var email    = emailEl ? emailEl.value.trim() : '';
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      if (errEl) errEl.style.display = 'block';
      return;
    }
    if (errEl) errEl.style.display = 'none';
    bcq('email');
    /* Save prenom */
    var prenom = prenomEl ? prenomEl.value.trim() : '';
    QZ.prenom = prenom;
    if (prenom) localStorage.setItem('qz-prenom', prenom);
    /* Klaviyo — envoi profil + reponses (fire-and-forget) */
    try { qzSendKlaviyo(email, prenom); } catch (e) {}
    qzStartTransition();
  };

  /* ── Klaviyo integration ── */
  var KLAVIYO_ENDPOINT = 'https://os-cro.vercel.app/api/klaviyo/subscribe';
  function qzKlaviyoPayload(email, prenom) {
    var m = QZ.answers[0] || '';
    var machine_type =
      m.indexOf('Original') !== -1 ? 'Nespresso original ou compatible' :
      m.indexOf('Vertuo')   !== -1 ? 'Nespresso vertuo' :
      m.indexOf('Dolce Gusto') !== -1 ? 'Dolce Gusto' :
      m.indexOf('Senseo')   !== -1 ? 'Senseo' :
      m.indexOf('Tassimo')  !== -1 ? 'Tassimo' : 'Autre';
    var h = QZ.answers[1] || '';
    var household_size =
      h.indexOf('Moi uniquement') !== -1 ? 1 :
      h.indexOf('conjoint')       !== -1 ? 2 : '3+';
    var consentEl = document.getElementById('qz-consent');
    return {
      email: email,
      first_name: prenom || '',
      machine_type: machine_type,
      household_size: household_size,
      coffee_per_day: QZ.answers[2] || '',
      coffee_purchase_channel: QZ.answers[3] || '',
      coffee_goal: QZ.answers[4] || '',
      estimated_savings_5y: (QZ.savings || calcSavings()) * 5,
      quiz_completed: true,
      quiz_source: 'capsme_savings_calculator',
      consent: !!(consentEl && consentEl.checked)
    };
  }
  function qzSendKlaviyo(email, prenom) {
    var payload = qzKlaviyoPayload(email, prenom);
    try {
      fetch(KLAVIYO_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
        keepalive: true
      }).catch(function () {});
    } catch (e) {}
  }

  /* ── Transition — dark shell + segmented items ── */
  function qzStartTransition() {
    QZ.step = 'transition';
    updateProgress();
    setShellClass('dark');
    showScreen('scr-transition');
    updateBackBtn();
    updateMobPhoto();
    var col = document.getElementById('quiz-col-left');
    if (col) col.scrollTop = 0;

    var bar      = document.getElementById('qz-ts-progress');
    var pctEl    = document.getElementById('qz-ts-pct');
    var startMs  = performance.now();
    var totalMs  = 2200;
    var stepDone = [false, false, false];

    var CHECK_SVG = '<svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M2 6L5 9L10 3" stroke="#fdf5dd" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    var DOT_SVG   = '<div class="ts-dot"></div>';

    function setItem(i, state) {
      var el = document.getElementById('qz-ts-item-' + i);
      if (!el) return;
      el.className = 'ts-item ' + state;
      var icon = el.querySelector('.ts-icon');
      if (!icon) return;
      if (state === 'done')    icon.innerHTML = CHECK_SVG;
      else if (state === 'loading') icon.innerHTML = DOT_SVG;
      else icon.innerHTML = '<div class="ts-dot ts-dot-idle"></div>';
    }

    function animate(now) {
      var elapsed = now - startMs;
      var pct     = Math.min(elapsed / totalMs, 1) * 100;
      if (bar) bar.style.width = pct + '%';
      if (pctEl) pctEl.textContent = Math.round(pct) + '%';

      if (!stepDone[0] && elapsed > 100)  { stepDone[0] = true; setItem(0, 'loading'); }
      if (!stepDone[1] && elapsed > 900)  { stepDone[1] = true; setItem(0, 'done'); setItem(1, 'loading'); }
      if (!stepDone[2] && elapsed > 1700) { stepDone[2] = true; setItem(1, 'done'); setItem(2, 'loading'); }

      if (pct < 100) {
        requestAnimationFrame(animate);
      } else {
        setItem(2, 'done');
        var circle = document.getElementById('qz-ts-icon');
        if (circle) circle.innerHTML = '<span style="font-size:30px;display:block;line-height:1">💰</span>';
        setTimeout(function() { routeToResult(); }, 400);
      }
    }
    requestAnimationFrame(animate);
  }

  /* ── Route to result ── */
  function routeToResult() {
    var key = getMachineKey();
    bcq('complete', { machine: key, result: (key === 'nes' || key === 'ndg' || key === 'sen') ? '5a' : '5b' });
    var overlay = document.getElementById('qz-overlay');
    if (overlay) overlay.style.display = 'none';

    /* barre preview masquée — non présente sur la page live */

    if (key === 'nes' || key === 'ndg' || key === 'sen') {
      buildRes5a(QZ.savings);
      var el = document.getElementById('result-5a');
      if (el) el.style.display = '';
      document.getElementById('cm-preview-title').textContent = 'Caps\'me LP — Résultat 5a (compatible)';
      document.getElementById('cm-preview-sub').textContent = ' — Machine : ' + MACHINE_PRICES[key].label;
    } else {
      buildRes5b(QZ.savings);
      var el = document.getElementById('result-5b');
      if (el) el.style.display = '';
      document.getElementById('cm-preview-title').textContent = 'Caps\'me LP — Résultat 5b (non compatible)';
      document.getElementById('cm-preview-sub').textContent = ' — Machine : ' + MACHINE_PRICES[key].label;
    }

    document.body.style.background = '';
    window.scrollTo(0, 0);
    initLpJs();

  }

  /* ── Build res5a v5 ── */
  function buildRes5a(savings) {
    var key   = getMachineKey();
    var md    = MACHINE_DATA[key];
    var mp    = MACHINE_PRICES[key];
    var cafes = getCafesJour();
    var pers  = getPersonnes();
    var IMG   = IMG_BASE + '';

    /* Calculations */
    var economiesAn   = Math.round(mp.economie * cafes * pers * 365);
    var economies5ans = economiesAn * 5;
    var savingsPct    = Math.round((mp.prixActuel - mp.benchmark) / mp.prixActuel * 100);
    var capsulesAn    = Math.round(cafes * pers * 365);
    var capsulesTot5  = capsulesAn * 5;
    var parMois       = Math.round(economiesAn / 12);
    var eco           = mp.economie.toFixed(3).replace('.', ',');
    var formula       = eco + '€ × ' + cafes + ' café' + (cafes > 1 ? 's' : '') + '/j × ' + pers + ' pers. × 365 j';

    /* Labels */
    function getCafesLabel(n) {
      if (n <= 1) return '1 café/jour';
      if (n <= 2) return '1-2 cafés/jour';
      if (n <= 4) return '3-4 cafés/jour';
      return '5+ cafés/jour';
    }
    function getPersonnesLabel(n) {
      if (n <= 1) return 'Solo';
      if (n <= 2) return 'En couple';
      return 'En famille';
    }
    var cafesLabel     = getCafesLabel(cafes);
    var personnesLabel = getPersonnesLabel(pers);

    /* Machine color */
    var MC = { nes: '#193254', ndg: '#cd5451', sen: '#4c6b45' };
    var machineColor = MC[key] || '#11312b';

    /* Image paths */
    var PACKSHOT = { nes: IMG+'packshot-nes.webp', ndg: IMG+'packshot-ndg.webp', sen: IMG+'packshot-sen.webp' };
    var COFFRET  = { nes: IMG+'coffret-nes.webp', ndg: IMG+'coffret-ndg.webp', sen: IMG+'coffret-sen.webp' };
    var CAPSULE  = { nes: IMG+'capsule-nes.png',  ndg: IMG+'capsule-ndg.png',  sen: IMG+'capsule-sen.png' };
    var CTA_BG   = { nes: IMG+'cta-bg-nes.webp',   ndg: IMG+'cta-bg-ndg.webp',  sen: IMG+'cta-bg-sen.webp' };

    var packshotUrl = PACKSHOT[key] || PACKSHOT.nes;
    var coffretUrl  = COFFRET[key]  || COFFRET.nes;
    var capsuleUrl  = CAPSULE[key]  || CAPSULE.nes;
    var ctaBgUrl    = CTA_BG[key]   || CTA_BG.nes;
    var productUrl  = md ? md.productUrl : '#';

    /* Prenom */
    var prenom = QZ.prenom || '';

    /* ── Hero grid ── */
    var heroHtml = [
      '<div class="res5a-hero-grid">',
      '  <div class="res5a-hero">',
      '    <div class="res5a-hero-block">',
      '    <div class="res5a-hero-headline">',
      (prenom ? '      <span class="res5a-hero-name">' + prenom + ', </span>' : ''),
      '      <span class="res5a-hero-tagline">voici votre résultat</span>',
      '    </div>',
      '    <div class="res5a-savings-hero">',
      '      <p class="res5a-savings-context">avec Caps\'me, vous économisez</p>',
      '      <div class="res5a-savings-body">',
      '        <div class="res5a-savings-main">',
      '          <div class="res5a-savings-display">',
      '            <div class="res5a-savings-num-wrap">',
      '              <span class="res5a-savings-num" id="res5a-savings-big">0</span>',
      '              <span class="res5a-savings-per">sur 5 ans</span>',
      '            </div>',
      '            <span class="res5a-savings-currency"> €</span>',
      '          </div>',
      '        </div>',
      '        <div class="res5a-savings-aside">',
      '          <div class="res5a-savings-5ans-tag">Soit ' + economiesAn + '€/an</div>',
      '          <p class="res5a-savings-aside-sub">= ' + parMois + ' € / mois</p>',
      '        </div>',
      '      </div>',
      '      <div class="res5a-savings-divider"></div>',
      '      <div class="res5a-profile-mini">',
      '        <span class="res5a-profile-mini-label">Vos réponses</span>',
      '        <div class="res5a-profile-mini-answers">',
      '          <span class="res5a-profile-mini-item"><svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 8h1a4 4 0 1 1 0 8h-1"/><path d="M3 8h14v9a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4z"/></svg>' + mp.label + '</span>',
      '          <span class="res5a-profile-mini-sep">·</span>',
      '          <span class="res5a-profile-mini-item">' + cafesLabel + '</span>',
      '          <span class="res5a-profile-mini-sep">·</span>',
      '          <span class="res5a-profile-mini-item">' + personnesLabel + '</span>',
      '        </div>',
      '      </div>',
      '    </div>',
      '    <div class="res5a-accordion-wrap">',
      '      <div class="res2-accordion" aria-expanded="false" id="cm-acc-hero-5a">',
      '        <button type="button" class="res2-accordion-trigger" onclick="cmToggleAcc(\'cm-acc-hero-5a\')">',
      '          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>',
      '          <span>Comment ce calcul est-il réalisé ?</span>',
      '          <svg class="cm-chevron" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>',
      '        </button>',
      '        <div class="res2-accordion-body"><div class="res2-accordion-content">',
      '          <div class="res2-calc-row"><span>Prix capsule actuelle (' + mp.label + ') :</span><strong>' + mp.prixActuel.toFixed(2).replace('.', ',') + '€ / café</strong></div>',
      '          <div class="res2-calc-row"><span>Prix Caps\'me (café moulu) :</span><strong>' + mp.benchmark.toFixed(3).replace('.', ',') + '€ / café</strong></div>',
      '          <div class="res2-calc-row res2-calc-row--accent"><span>Économie par café :</span><strong>' + eco + '€</strong></div>',
      '          <div class="res2-calc-formula">' + formula + '<span class="res2-calc-result">= ' + economiesAn + '€/an</span></div>',
      '          <p class="res2-calc-note">Le prix Caps\'me correspond au coût du café moulu de qualité équivalente.</p>',
      '        </div></div>',
      '      </div>',
      '    </div>',
      '    </div>',
      '    <img src="' + packshotUrl + '" alt="Coffret Caps\'me ' + mp.label + '" class="res5a-hero-pack-mobile">',
      '  </div>',
      '  <div class="res5a-hero-side">',
      '    <div class="res5a-hero-side-wrap">',
      '      <img src="' + packshotUrl + '" alt="Coffret Caps\'me ' + mp.label + '" class="res5a-hero-side-img">',
      '      <div class="res5a-hero-img-overlay"></div>',
      '      <div class="res5a-hero-cta-overlay-positioner">',
      '        <a href="#res5a-cta" onclick="this.href=\'#res5a-cta\'" class="res5a-hero-cta-overlay">',
      '          <span class="res5a-hero-cta-overlay-text">Économisez <strong>' + economies5ans + '€</strong> avec Caps\'me</span>',
      '          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="5" x2="12" y2="19"/><polyline points="19 12 12 19 5 12"/></svg>',
      '        </a>',
      '      </div>',
      '    </div>',
      '    <div class="res5a-hero-compat-tag">',
      '      <span class="res5a-compat-dot" style="background:' + machineColor + '"></span>',
      '      Compatible ' + mp.label,
      '    </div>',
      '  </div>',
      '</div>'
    ].join('\n');

    /* ── Compare ── */
    var compareHtml = [
      '<div class="res5a-compare">',
      '  <div class="res5a-compare-header">',
      '    <p class="res5a-section-eyebrow" style="color:#FFC823;margin-bottom:6px;text-align:center">POURQUOI CAPS\'ME</p>',
      '    <h3 class="res5a-section-title" style="text-align:center;margin-bottom:4px">Votre café vous coûte<br>trop cher aujourd\'hui</h3>',
      '    <p class="res5a-compare-header-sub">Comparez le coût réel de votre capsule vs Caps\'me + café moulu de qualité</p>',
      '  </div>',
      '  <div class="res5a-compare-inner">',
      '    <div class="res5a-compare-panel res5a-compare-panel--before">',
      '      <p class="res5a-compare-panel-eyebrow">Sans Caps\'me</p>',
      '      <div class="res5a-compare-img-circle">',
      '        <img src="' + capsuleUrl + '" alt="Capsule jetable">',
      '      </div>',
      '      <p class="res5a-compare-panel-name">Capsule jetable<br>' + mp.label + '</p>',
      '      <div class="res5a-compare-price-big">',
      '        <span class="res5a-compare-num">' + mp.prixActuel.toFixed(2).replace('.', ',') + '</span>',
      '        <span class="res5a-compare-currency">€</span>',
      '        <span class="res5a-compare-per-label">/café</span>',
      '      </div>',
      '      <ul class="res5a-compare-cons">',
      '        <li>Plastique non recyclable</li>',
      '        <li>Goût standardisé, peu d\'origine</li>',
      '        <li>Prix imposé par la marque</li>',
      '      </ul>',
      '    </div>',
      '    <div class="res5a-compare-versus">',
      '      <div class="res5a-compare-pct-badge">',
      '        <span class="res5a-compare-pct-num">−' + savingsPct + '%</span>',
      '        <span class="res5a-compare-pct-label">avec Caps\'me</span>',
      '      </div>',
      '    </div>',
      '    <div class="res5a-compare-panel res5a-compare-panel--after">',
      '      <p class="res5a-compare-panel-eyebrow">Avec Caps\'me ✦</p>',
      '      <div class="res5a-compare-img-circle res5a-compare-img-circle--after">',
      '        <img src="' + coffretUrl + '" alt="Coffret Caps\'me">',
      '      </div>',
      '      <p class="res5a-compare-panel-name">Caps\'me + café<br>moulu de qualité</p>',
      '      <div class="res5a-compare-price-big res5a-compare-price-big--green">',
      '        <span class="res5a-compare-num">' + mp.benchmark.toFixed(2).replace('.', ',') + '</span>',
      '        <span class="res5a-compare-currency">€</span>',
      '        <span class="res5a-compare-per-label">/café</span>',
      '      </div>',
      '      <ul class="res5a-compare-pros">',
      '        <li><span class="res5a-compare-pros-icon"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg></span>Capsule réutilisable 1 000×</li>',
      '        <li><span class="res5a-compare-pros-icon"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></svg></span>Tous les cafés du monde</li>',
      '        <li><span class="res5a-compare-pros-icon"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg></span>Amorti en ~3 mois</li>',
      '      </ul>',
      '    </div>',
      '  </div>',
      '  <div class="res5a-compare-impact-block">',
      '    <div class="res5a-compare-impact-inner">',
      '      <span class="res5a-compare-impact-icon"><svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" width="32" height="32"><path d="M16 4C9.37 4 4 9.37 4 16s5.37 12 12 12 12-5.37 12-12S22.63 4 16 4zm0 2c5.52 0 10 4.48 10 10s-4.48 10-10 10S6 21.52 6 16 10.48 6 16 6z" fill="currentColor"/><path d="M16 9c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-4.5 5.5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm9 0c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm-4.5 3c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2h2c0-2.21-1.79-4-4-4z" fill="currentColor"/><path d="M11 9.5l1.8 3.1M21 9.5l-1.8 3.1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg></span>',
      '      <div class="res5a-compare-impact-text">',
      '        <span class="res5a-compare-impact-num">' + capsulesAn.toLocaleString('fr-FR') + '</span>',
      '        <span class="res5a-compare-impact-label">capsules plastiques évitées par an</span>',
      '        <span class="res5a-compare-impact-sub">Soit ' + capsulesTot5.toLocaleString('fr-FR') + ' capsules sur 5 ans.</span>',
      '        <span class="res5a-compare-impact-highlight">Une seule capsule Caps\'me remplace <strong>1 000 capsules.</strong></span>',
      '      </div>',
      '    </div>',
      '  </div>',
      '</div>'
    ].join('\n');

    /* ── Edu ── */
    var EDU_TEXT = [
      'Avec les capsules jetables, vous payez pour un emballage jeté après une seule utilisation.',
      'Avec Caps\'me, vous réutilisez votre capsule. Ce que vous consommez vraiment, c\'est le café moulu : plus il est accessible, plus chaque tasse vous revient moins cher.',
      'Résultat : vous maîtrisez le prix de chaque tasse, sans changer de machine, avec le café que vous aimez.'
    ];
    var eduRows = [
      '<div class="res5a-edu">',
      '  <h3 class="res5a-edu-title">Pourquoi votre café vous coûte plus cher aujourd\'hui ?</h3>',
      '  <div class="res5a-edu-steps" id="res5a-edu-steps">'
    ];
    for (var i = 0; i < EDU_TEXT.length; i++) {
      eduRows.push(
        '    <div class="res5a-edu-step">',
        '      <div class="res5a-edu-step-img"><img src="' + IMG + 'edu_' + (i+1) + '.webp" alt=""></div>',
        '      <div class="res5a-edu-step-body">',
        '        <div class="res5a-edu-num-wrap"><span class="res5a-edu-num">' + (i+1) + '</span></div>',
        '        <p class="res5a-edu-p">' + EDU_TEXT[i] + '</p>',
        '      </div>',
        '    </div>'
      );
    }
    eduRows.push(
      '  </div>',
      '  <div class="res5a-edu-dots" id="res5a-edu-dots">',
      '    <span class="res5a-edu-dot active"></span>',
      '    <span class="res5a-edu-dot"></span>',
      '    <span class="res5a-edu-dot"></span>',
      '  </div>',
      '</div>'
    );
    var eduHtml = eduRows.join('\n');

    /* ── CTA ── */
    var ctaHtml = [
      '<div class="res5a-cta" id="res5a-cta">',
      '  <div class="res5a-cta-bg">',
      '    <img src="' + ctaBgUrl + '" alt="" class="res5a-cta-bg-img" aria-hidden="true">',
      '    <div class="res5a-cta-bg-overlay"></div>',
      '  </div>',
      '  <div class="res5a-cta-content">',
      '    <p class="res5a-cta-machine-badge"><svg width="10" height="10" viewBox="0 0 24 24" fill="currentColor"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg> Coffret Caps\'me · Compatible ' + mp.label + '</p>',
      '    <h2 class="res5a-cta-headline">' + (prenom ? prenom + ', prêt(e)' : 'Prêt(e)') + ' à passer<br><span class="res5a-cta-headline-accent">à un café qui vaut le coup ?</span></h2>',
      '    <ul class="res5a-cta-features">',
      '      <li><span class="res5a-cta-feature-icon"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/><path d="M3 3v5h5"/><path d="M12 7v5l4 2"/></svg></span><span>Capsule réutilisable <strong>+1 000 cafés</strong></span></li>',
      '      <li><span class="res5a-cta-feature-icon"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M15 9.354a4 4 0 1 0 0 5.292"/><path d="M12 7v1m0 8v1"/></svg></span><span>Jusqu\'à <strong>' + economiesAn + '€/an</strong> économisés sur votre café</span></li>',
      '      <li><span class="res5a-cta-feature-icon"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="3" width="15" height="13" rx="1"/><path d="M16 8h4l3 5v3h-7V8z"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg></span><span>Livraison offerte · Retours 30 jours</span></li>',
      '    </ul>',
      '    <div class="res5a-cta-group">',
      '      <div class="res5a-cta-promo-banner">',
      '        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>',
      '        10% offert pendant 24h sur votre première commande !',
      '      </div>',
      '      <a href="' + productUrl + '?discount=BIENVENUE10" target="_blank" rel="noopener" class="res5a-cta-btn">',
      '        Découvrir Caps\'me',
      '        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><polyline points="9 18 15 12 9 6"/></svg>',
      '      </a>',
      '      <button class="res5a-copy-link" id="res5a-copy-btn" type="button" onclick="copyCapsmeCode()">',
      '        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>',
      '        Copier le code BIENVENUE10',
      '      </button>',
      '      <p class="res5a-trust">★★★★★ 6 000+ clients · Livraison offerte dès 50€ · Paiement sécurisé</p>',
      '    </div>',
      '  </div>',
      '</div>'
    ].join('\n');

    /* ── Inject ── */
    var dynHero = document.getElementById('res5a-hero-dyn');
    if (dynHero) dynHero.innerHTML = heroHtml;

    var dynCompare = document.getElementById('res5a-compare-dyn');
    if (dynCompare) dynCompare.innerHTML = compareHtml;

    var dynEdu = document.getElementById('res5a-edu-dyn');
    if (dynEdu) dynEdu.innerHTML = eduHtml;

    var dynCta = document.getElementById('res5a-cta-dyn');
    if (dynCta) dynCta.innerHTML = ctaHtml;

    /* ── Sticky values ── */
    var stickyNum = document.getElementById('res5a-sticky-num');
    var stickySub = document.getElementById('res5a-sticky-sub');
    var stickyBtn = document.getElementById('res5a-sticky-btn');
    if (stickyNum) stickyNum.innerHTML = '+' + economiesAn + '€<span class="res5a-sticky-per">/an</span>';
    if (stickySub) stickySub.textContent = 'soit ' + parMois + '€/mois économisés';
    if (stickyBtn) { stickyBtn.href = '#res5a-cta'; stickyBtn.removeAttribute('target'); }

    /* ── Countup animation (0 → economies5ans over 1400ms ease-out cubic) ── */
    var bigEl = document.getElementById('res5a-savings-big');
    if (bigEl) {
      var startT = performance.now();
      var dur    = 1400;
      var target = economies5ans;
      (function tick(now) {
        var t    = Math.min((now - startT) / dur, 1);
        var ease = 1 - Math.pow(1 - t, 3);
        bigEl.textContent = Math.round(ease * target);
        if (t < 1) requestAnimationFrame(tick);
      })(startT);
    }

    /* ── Edu dots sync (mobile scroll) ── */
    setTimeout(function() {
      var stepsEl = document.getElementById('res5a-edu-steps');
      var dotsEl  = document.getElementById('res5a-edu-dots');
      if (!stepsEl || !dotsEl) return;
      var dots = dotsEl.querySelectorAll('.res5a-edu-dot');
      stepsEl.addEventListener('scroll', function() {
        var stepW = stepsEl.scrollWidth / 3;
        var idx   = Math.round(stepsEl.scrollLeft / stepW);
        dots.forEach(function(d, i) { d.classList.toggle('active', i === idx); });
      }, { passive: true });
    }, 200);
  }

  /* ── Build res5b savings update ── */
  function buildRes5b(savings) {
    var key    = getMachineKey();
    var mp     = MACHINE_PRICES[key];
    var cafes  = getCafesJour();
    var pers   = getPersonnes();
    var eco    = mp.economie.toFixed(3).replace('.', ',');
    var prenom = QZ.prenom || '';

    /* Update eyebrow with prenom */
    var eyebrowEl = document.getElementById('res5b-hero-eyebrow');
    if (eyebrowEl) eyebrowEl.textContent = prenom ? prenom.toUpperCase() + ', VOICI VOTRE SIMULATION' : 'VOICI VOTRE SIMULATION';

    /* Update compat notice with machine label */
    var compatEl = document.getElementById('res5b-compat-notice');
    if (compatEl) compatEl.innerHTML = '<span>Votre machine <strong>(' + mp.label + ')</strong> n\'est pas encore compatible, rejoignez la liste ci-dessous pour être alerté en priorité.</span>';

    /* Update amount el */
    var amtEl = document.getElementById('res5b-savings-amount');
    if (amtEl) { amtEl.textContent = savings; amtEl.dataset.target = savings; }

    /* Update accordion */
    var pc = document.getElementById('res5b-price-current');
    var pe = document.getElementById('res5b-price-eco');
    var pf = document.getElementById('res5b-calc-formula');
    var pr = document.getElementById('res5b-calc-result');
    if (pc) pc.textContent = mp.prixActuel.toFixed(2).replace('.', ',') + '€ / café';
    if (pe) pe.textContent = eco + '€';
    if (pf) pf.textContent = eco + '€ × ' + cafes + ' café' + (cafes > 1 ? 's' : '') + '/j × ' + pers + ' pers. × 365 j';
    if (pr) pr.textContent = '= ' + savings + '€/an';
  }

  /* ═══════════════════════════════════════════════════════
     LP JS (actif après affichage du résultat)
  ═══════════════════════════════════════════════════════ */
  function initLpJs() {

    /* FAQ accordion */
    window.cmToggleFaq = function(btn) {
      var item = btn.closest('[data-faq-item]');
      if (!item) return;
      var isOpen = item.classList.contains('res5a-faq-item--open');
      item.parentElement.querySelectorAll('[data-faq-item]').forEach(function(s) { s.classList.remove('res5a-faq-item--open'); });
      if (!isOpen) item.classList.add('res5a-faq-item--open');
    };

    /* Calc accordion */
    window.cmToggleAcc = function(id) {
      var el = document.getElementById(id);
      if (!el) return;
      el.setAttribute('aria-expanded', el.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
    };

    /* Reviews carousel */
    window.cmCarouselScroll = function(id, dir) {
      var el = document.getElementById(id);
      if (!el) return;
      var card = el.querySelector('.res5a-review-card');
      if (!card) return;
      el.scrollBy({ left: dir * (card.offsetWidth + 12), behavior: 'smooth' });
    };

    /* Press ticker RAF */
    document.querySelectorAll('.cm-press-track').forEach(function(track) {
      var pos = 0;
      function start() {
        var halfW = track.scrollWidth / 3;
        (function step() {
          pos = (pos + 0.5) % halfW;
          track.style.transform = 'translateX(-' + pos + 'px)';
          requestAnimationFrame(step);
        })();
      }
      setTimeout(start, 150);
    });

    /* Sticky 5b waitlist */
    var stickyEl  = document.getElementById('cm-sticky-main');
    var triggerEl = document.getElementById('cm-wl-form-wip');
    if (stickyEl && triggerEl) {
      window.addEventListener('scroll', function() {
        stickyEl.classList.toggle('is-visible', triggerEl.getBoundingClientRect().bottom < 0);
      }, { passive: true });
    }

    /* Sticky 5a — apparaît dès que la section hero sort du viewport, disparaît sur la section CTA */
    var sticky5a = document.getElementById('res5a-sticky');
    if (sticky5a) {
      window.addEventListener('scroll', function() {
        var heroEl = document.querySelector('#result-5a .res5a-hero-grid');
        if (!heroEl) return;
        var ctaEl = document.querySelector('#result-5a .res5a-cta');
        var heroGone = heroEl.getBoundingClientRect().bottom < 0;
        var ctaVisible = ctaEl && ctaEl.getBoundingClientRect().top < window.innerHeight;
        sticky5a.classList.toggle('is-visible', heroGone && !ctaVisible);
      }, { passive: true });
    }

    /* Copy promo code */
    window.copyCapsmeCode = function() {
      var code = 'BIENVENUE10';
      var btn  = document.getElementById('res5a-copy-btn');
      if (navigator.clipboard) {
        navigator.clipboard.writeText(code).then(function() {
          if (btn) { btn.textContent = '✓ Code copié !'; setTimeout(function() { btn.innerHTML = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg> Copier le code ' + code; }, 2000); }
        });
      } else {
        var ta = document.createElement('textarea');
        ta.value = code; ta.style.position = 'fixed'; ta.style.opacity = '0';
        document.body.appendChild(ta); ta.select();
        document.execCommand('copy');
        document.body.removeChild(ta);
        if (btn) { btn.textContent = '✓ Code copié !'; setTimeout(function() { btn.innerHTML = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg> Copier le code ' + code; }, 2000); }
      }
    };

    /* Waitlist submit */
    window.cmWaitlistSubmit = function(ev, blockId) {
      ev.preventDefault();
      var emailEl = document.getElementById('cm-wl-email-' + blockId);
      var errEl   = document.getElementById('cm-wl-err-'   + blockId);
      var doneEl  = document.getElementById('cm-wl-done-'  + blockId);
      var formEl  = ev.target;
      var email   = emailEl ? emailEl.value.trim() : '';
      if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        if (errEl) errEl.style.display = 'block';
        return;
      }
      if (errEl) errEl.style.display = 'none';
      formEl.style.display = 'none';
      if (doneEl) doneEl.classList.add('is-visible');
      var sf = document.querySelector('.res5b-sticky-form');
      var sd = document.querySelector('.res5b-sticky-done');
      if (sf) sf.classList.add('is-done');
      if (sd) sd.classList.add('is-visible');
    };

    /* Sticky submit */
    window.cmStickySubmit = function(ev, id) {
      ev.preventDefault();
      var emailEl = document.getElementById('cm-sticky-email-' + id);
      var formEl  = document.getElementById('cm-sticky-form-'  + id);
      var doneEl  = document.getElementById('cm-sticky-done-'  + id);
      var email   = emailEl ? emailEl.value.trim() : '';
      if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return;
      if (formEl) formEl.classList.add('is-done');
      if (doneEl) doneEl.classList.add('is-visible');
      var mf = document.querySelector('.cm-waitlist-form');
      var md = document.querySelector('.cm-form-done');
      if (mf) mf.style.display = 'none';
      if (md) md.classList.add('is-visible');
    };

    /* Scroll reveal */
    if ('IntersectionObserver' in window) {
      var revealObs = new IntersectionObserver(function(entries) {
        entries.forEach(function(e) {
          if (!e.isIntersecting) return;
          e.target.classList.add('in');
          revealObs.unobserve(e.target);
        });
      }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
      document.querySelectorAll('.cm-reveal').forEach(function(el) { revealObs.observe(el); });
    }

    /* CountUp */
    if ('IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function(entries) {
        entries.forEach(function(e) {
          if (!e.isIntersecting) return;
          obs.unobserve(e.target);
          var el     = e.target;
          var target = parseFloat(el.dataset.target);
          var start  = performance.now();
          (function tick(now) {
            var t = Math.min((now - start) / 1200, 1);
            var eased = 1 - Math.pow(1 - t, 3);
            el.textContent = Math.round(target * eased).toLocaleString('fr-FR');
            if (t < 1) requestAnimationFrame(tick);
          })(start);
        });
      }, { rootMargin: '-60px' });
      document.querySelectorAll('.cm-countup[data-target]').forEach(function(el) { obs.observe(el); });
    }
  }

  /* ── Init ── */
  updatePhoto('intro');
  showScreen('scr-intro');
  bcqView();

})();